import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import AccountInfo from "./Components/AccountInfo";
import Missions from "./Components/Missions";
import MainStats from "./Components/MainStats";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { API_BASE_URL } from "../../config/api";
import { AsyncContent } from "../../Components/AsyncState";
import { authFetch } from "../../api/authFetch";
export default function Overview() {
  const { accountId } = useParams();
  const [accountData, setAccountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const fetchAccountData = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const [rulesResponse, detailResponse] = await Promise.all([
        authFetch(`${API_BASE_URL}/api/v0/challenges/trader/accounts/${accountId}/rules/`),
        authFetch(`${API_BASE_URL}/api/v0/challenges/admin/accounts/${accountId}/data/`),
      ]);
      if (!rulesResponse?.ok || !detailResponse?.ok) throw new Error("Account request failed");
      const [rules, detail] = await Promise.all([rulesResponse.json(), detailResponse.json()]);
      setAccountData({ ...detail, ...rules });
    } catch (error) {
      console.error("Error fetching account data:", error);
      setError("خطا در دریافت اطلاعات حساب");
    } finally {
      setLoading(false);
    }
  }, [accountId]);
  useEffect(() => {
    fetchAccountData();
  }, [fetchAccountData]);
  return (
    <LayoutPage
      activeIndex={2}
      navItems={["حساب‌ها و چالش‌ها", `حساب ${accountId}`]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <NavLayer2
        texts={["حساب در یک نگاه", "جزئیات معاملات"]}
        hrefs={[
          `/account/${accountId}/overview`,
          `/account/${accountId}/trade-detail`,
        ]}
        activeIndex={0}
      />
      <AsyncContent loading={loading} error={error} empty={!accountData} onRetry={fetchAccountData}>
      <div className="w-full h-fit flex flex-col sm:flex-row gap-5 min-h-0 overflow-y-auto">
        <div className="flex-1 min-w-0 h-fit flex flex-col gap-5">
          <AccountInfo accountData={accountData} />
          <Missions accountData={accountData} />
        </div>

        <div className="w-full sm:size-fit flex flex-col gap-5">
          <MainStats accountData={accountData} />
        </div>
      </div>
      </AsyncContent>
    </LayoutPage>
  );
}
